import React, { useRef, useState } from "react";
import { useInView } from "framer-motion";
import styled from "styled-components";
import {
  Wrapper,
  ProcessCard,
  CardWrapper,
  ProcessExtract,
  ProcessSelector,
  ProcessSummary,
  ProcessTitle,
  ProcessTopRow,
} from "./ProcessGrid.styles";

import { PROCESS, PROCESS_DEF } from "../../data";
import { QUERIES } from "../../constants";

const cardStyles = {
  hidden: {
    y: "30%",
    opacity: 0,
  },
  show: {
    y: "0%",
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.37, 0, 0.63, 1],
    },
  },
};

export default function ProcessGrid() {
  return (
    <Wrapper>
      <ProcessSummary>{PROCESS_DEF}</ProcessSummary>
      {PROCESS.map((process) => (
        <CardWrapperfn key={process.selector}>
          <ProcessCard>
            <ProcessTopRow>
              <ProcessTitle>{process.title}</ProcessTitle>
              <ProcessSelector
                style={{
                  color: `${process.color}`,
                }}
              >
                {process.selector}
              </ProcessSelector>
            </ProcessTopRow>
            <ProcessExtract>{process.extract}</ProcessExtract>
          </ProcessCard>
        </CardWrapperfn>
      ))}
    </Wrapper>
  );
}

export function MobileProcessGrid() {
  const [viewMore, setViewMore] = useState(false);

  return (
    <MobileWrapper>
      <ProcessSummary>{PROCESS_DEF}</ProcessSummary>
      <VisibleColumn>
        {PROCESS.slice(0, 2).map((process) => (
          <CardWrapperfn key={process.selector}>
            <ProcessCard>
              <ProcessTopRow>
                <ProcessTitle>{process.title}</ProcessTitle>
                <ProcessSelector
                  style={{
                    color: `${process.color}`,
                  }}
                >
                  {process.selector}
                </ProcessSelector>
              </ProcessTopRow>
              <ProcessExtract>{process.extract}</ProcessExtract>
            </ProcessCard>
          </CardWrapperfn>
        ))}
      </VisibleColumn>
      <HiddenColumn
        style={{
          "--panel-height": viewMore ? "1200px" : "0",
        }}
      >
        {PROCESS.slice(2, 5).map((process) => (
          <CardWrapperfn key={process.selector}>
            <ProcessCard>
              <ProcessTopRow>
                <ProcessTitle>{process.title}</ProcessTitle>
                <ProcessSelector
                  style={{
                    color: `${process.color}`,
                  }}
                >
                  {process.selector}
                </ProcessSelector>
              </ProcessTopRow>
              <ProcessExtract>{process.extract}</ProcessExtract>
            </ProcessCard>
          </CardWrapperfn>
        ))}
      </HiddenColumn>
      <ShowMore onClick={() => setViewMore(!viewMore)}>
        <ShowMoreText>View {viewMore ? "Less" : "More"}</ShowMoreText>
        <ChevronDown isRotated={viewMore} src=" /images/chevron-down.svg" />
      </ShowMore>
    </MobileWrapper>
  );
}

const MobileWrapper = styled(Wrapper)`
  display: none;

  @media ${QUERIES.phoneAndSmaller} {
    display: flex;
    flex-direction: column;
    padding: 0px;
  }
`;

const VisibleColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 120px;
  margin-inline: -10px;
  gap: 10px;
`;

const HiddenColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  align-items: center;
  /* margin-inline: -16px; */
  max-height: var(--panel-height);
  transition: max-height 850ms ease;
  overflow: hidden;
`;

const ShowMore = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  gap: 5px;
  flex-shrink: 1;
`;

const ChevronDown = styled.img`
  width: 24px;
  transform: ${({ isRotated }) =>
    isRotated ? `rotateX(180deg)` : `rotateX(0deg)`};
  transition: transform 350ms ease both;
`;

const ShowMoreText = styled.p`
  color: var(--color-offwhite);
`;

function CardWrapperfn({ children }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.2 });
  const showAnimation = isInView ? "show" : "initial";
  return (
    <Wrapperfn
      ref={ref}
      variants={cardStyles}
      initial="hidden"
      animate={showAnimation}
    >
      {children}
    </Wrapperfn>
  );
}

const Wrapperfn = styled(CardWrapper)`
  width: 100%;
`;
